"use client";

import {
  ChakraProvider,
  createSystem,
  defaultConfig,
  Theme,
} from "@chakra-ui/react";
import config from "../../theme.config";
import { ColorModeProvider, type ColorModeProviderProps } from "./color-mode";

const system = createSystem(defaultConfig, config);

export function ProviderChakra(props: ColorModeProviderProps) {
  return (
    <ChakraProvider value={system}>
      <Theme appearance="light">
        <ColorModeProvider {...props} />
      </Theme>
    </ChakraProvider>
  );
}
